import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { confirmAccountMergeRequest } from "../api/auth";
import AuthShell from "../components/auth/AuthShell";

function AccountMergeConfirmPage() {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");
  const [loading, setLoading] = useState(Boolean(token));
  const [statusMessage, setStatusMessage] = useState(token ? "Confirming the account-help request..." : "This account-help link is missing or invalid.");
  const [statusSeverity, setStatusSeverity] = useState(token ? "info" : "error");

  useEffect(() => {
    let mounted = true;
    async function confirm() {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        await confirmAccountMergeRequest(token);
        if (!mounted) return;
        setStatusMessage("Email ownership confirmed. TrustBud support can now review the account-help request.");
        setStatusSeverity("success");
      } catch (error) {
        if (!mounted) return;
        setStatusMessage(error.message || "This account-help link is invalid or expired.");
        setStatusSeverity("error");
      } finally {
        if (mounted) setLoading(false);
      }
    }
    confirm();
    return () => {
      mounted = false;
    };
  }, [token]);

  return (
    <AuthShell
      heroBadge="Account help"
      heroTitle="Confirm email ownership."
      heroBody="TrustBud does not automatically merge accounts. This gives support a verified request to review."
      eyebrow="Duplicate account help"
      title="Confirming the request."
      body="This protects both accounts before support reviews anything."
      maxWidth={980}
      reverseOnDesktop
    >
      <Stack spacing={2}>
        <Alert severity={statusSeverity} sx={{ borderRadius: 3 }}>
          {loading ? <CircularProgress size={16} sx={{ mr: 1 }} /> : null}
          {statusMessage}
        </Alert>
        <Box>
          <Button component={RouterLink} to="/login" variant="contained" sx={{ borderRadius: 999, textTransform: "none", fontWeight: 700 }}>
            Open TrustBud
          </Button>
        </Box>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          If this was not you, ignore the email or contact support@trustbud.app.
        </Typography>
      </Stack>
    </AuthShell>
  );
}

export default AccountMergeConfirmPage;
